import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=2964c65e&scoped=true&"
import script from "./LazyImage.vue?vue&type=script&lang=js&"
export * from "./LazyImage.vue?vue&type=script&lang=js&"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=2964c65e&lange=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964c65e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/LazyImage.vue
// module id = null
// module chunks = 